import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/EY-logo-monochromatic.svg'


const _withScopeId = n => (_pushScopeId("data-v-670089e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("nav", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "EY logo"
  })
], -1))
const _hoisted_2 = { class: "canvas" }

import WelcomeScreen from "./components/WelcomeScreen.vue";
import CardScreen from "./components/CardScreen.vue";
import FinalFormScreen from "./components/FinalFormScreen.vue";
import ClapScreen from "./components/ClapScreen.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(WelcomeScreen),
      _createVNode(CardScreen),
      _createVNode(FinalFormScreen),
      _createVNode(ClapScreen)
    ])
  ], 64))
}
}

})